import { render } from "./NFTCard.vue?vue&type=template&id=6e9be62a&scoped=true"
import script from "./NFTCard.vue?vue&type=script&lang=js"
export * from "./NFTCard.vue?vue&type=script&lang=js"

import "./NFTCard.vue?vue&type=style&index=0&id=6e9be62a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9be62a"]])

export default __exports__